import React from 'react';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div style={{padding:'12px 0', fontSize:14, color:'#475569', textAlign:'center'}}>
          © {new Date().getFullYear()} AromaVerse — crafted with care.
        </div>
      </div>
    </footer>
  );
}